import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Page, Component as BrComponent, Menu } from '@bloomreach/spa-sdk/';
import { BaseEntryProductComponent } from '@products/base-entry-product-component';
import { FundListingComponentConfig } from '@products/fund-listing/fund-listing-component.config';
import { FundListingDisplayComponent } from '@products/fund-listing/fund-listing-display-component.interface';
import {
  AsyncContentManagerService,
  RenderingStatus,
} from '@services/async-content-manager.service';
import { BrBreadcrumb } from '@types';
import { Logger } from '@utils/logger';
import { PpssServiceFactory } from '../services/ppss.service.factory';

const logger = Logger.getLogger('FundListingEntryComponent');

@Component({
  selector: 'ft-fund-listing-entry',
  templateUrl: './fund-listing-entry.component.html',
  styleUrls: ['./fund-listing-entry.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FundListingEntryComponent
  extends BaseEntryProductComponent
  implements OnInit, OnDestroy {
  @Input() component!: BrComponent;
  @Input() page!: Page;
  @ViewChild('dynamicCmp', { read: ViewContainerRef, static: false }) container;
  componentType: string;
  componentRef: ComponentRef<FundListingDisplayComponent>;
  componentConfig: FundListingComponentConfig;
  isLoading = true;
  errorMsg: string;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private changeDetector: ChangeDetectorRef,
    private ppssServiceFactory: PpssServiceFactory,
    private acm: AsyncContentManagerService
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.acm.update(this.component?.getId(), RenderingStatus.IN_PROGRESS, true);
    const config = this.component.getModels()?.config;
    this.componentType = config.componentType;
    this.componentConfig = FundListingComponentConfig.getConfig(
      this.componentType,
      this.configurationName
    );
    this.ppssServiceFactory.setCurrentProductType(this.configurationName);
    this.changeDetector.detectChanges(); // at this point show component if componentType exists

    if (this.componentConfig) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
        this.componentConfig.component
      );
      this.container.clear();
      this.componentRef = this.container.createComponent(componentFactory);
      this.isLoading = false;
      this.errorMsg = null;
      this.componentRef.instance.id = this.component.getId();
      this.componentRef.instance.populate(
        this.componentConfig,
        this.menu,
        this.breadcrumbs
      );
      this.changeDetector.detectChanges(); // to remove loading message
    } else {
      logger.error(
        'No component found: ',
        this.componentType,
        this.configurationName
      );
      this.errorMsg = `No component found: ${this.componentType}, ${this.configurationName}`;
    }
  }

  ngOnDestroy() {
    // clean up dynamic component to avoid memory leaks
    this.componentRef?.destroy();
  }

  /**
   * Read menu from data model
   */
  get menu(): Menu {
    return this.component.getModels<MenuModels>()?.menu;
  }

  /**
   * Read breadcrumbs from data model
   */
  get breadcrumbs(): BrBreadcrumb[] {
    return this.component.getModels()?.breadcrumbs;
  }
}
